import CourseSettingsService from 'services/course-handler-services/course-settings-service';
import EF from 'ef/ef';

const KeepAlive = () => {
  if (!EF.options.local) {
    setTimeout(() => {
      const portalBasePath = CourseSettingsService.get('portalBasePath');
      if (portalBasePath) {
        const headers = new Headers();
        headers.set('Accept', 'application/json');
        fetch(`${portalBasePath}/heartbeat`, {
          headers,
          credentials: 'include',
        });
      }
    }, 0);
  }
};

export default KeepAlive;
